export default "__VITE_ASSET__f86d6999__"